import { render } from "./header.area.vue?vue&type=template&id=4b1a702b"
import script from "./header.area.vue?vue&type=script&lang=js"
export * from "./header.area.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__